module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("pretty oriental purse")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2"
  }, [_vm._v("This simple-to-make little bag has more than enough room for your essentials – two side gussets mean that it is deceptively roomy despite its diminutive size. Finely woven cotton Japanese floral fabrics, used for the bag and its lining, perfectly complement the panel which adorns the bag front. For decorative detail, small buttons are sewn at the base of the handles.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/10-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A portrait of a geisha provides a wonderful focal point on the front of the bag. The geisha image is applied to a patch of plain green cotton fabric using transfer paste, and then edged with a ruffle-edged satin ribbon.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/11-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "need"
  }, [_vm._v("you will need …")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 10 × 15cm (4 × 6in) plain cotton fabric")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• image transfer paste")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• paintbrush")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• sponge")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 50cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("yd) patterned cotton fabric, 90cm (36in) wide, for bag")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 30cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("yd) patterned cotton fabric, 90cm (36in) wide, for lining")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• length of ruffled satin ribbon to fit around picture")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• two buttons")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• sewing threads to match fabrics")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("techniques")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#toc1"
    }
  }, [_vm._v("basic sewing kit")]), _vm._v(" … "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#toc2"
    }
  }, [_vm._v("using a sewing machine")]), _vm._v(" … "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#toc3"
    }
  }, [_vm._v("slipstitch")]), _vm._v(" … "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#toc4"
    }
  }, [_vm._v("sewing on buttons")]), _vm._v(" …")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("templates")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#toc5"
    }
  }, [_vm._v("geisha portrait")]), _vm._v(" … "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#toc6"
    }
  }, [_vm._v("bag body, base and gusset")]), _vm._v(" …")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("1")]), _vm._v(" Download the geisha portrait template and cut it out. Following the manufacturer’s instructions, paint transfer paste over the picture and press it face down onto the plain cotton fabric patch to transfer the image.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("2")]), _vm._v(" Dampen the back of the picture with a sponge and peel off the excess paper from the fabric. Leave to dry.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/12-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("If you choose a reversible fabric for the bag as shown, the gussets, base and handles can contrast with the bag front and back.")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("3")]), _vm._v(" Download the bag body, base and gusset patterns for the pretty oriental purse template. Cut out the pattern pieces: cut one front, one back, two gussets and one base from both the bag and the lining fabric. For the handles, cut two strips measuring 7 × 40cm (3 × 15"), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) from the bag fabric only.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/13-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("4")]), _vm._v(" Neatly trim the geisha picture and pin it to the centre of the bag front. Machine stitch the picture in place, using as narrow a seam allowance as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("5")]), _vm._v(" With right sides together, pin the base to the bag front. Machine stitch using a 1.5cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("in) seam allowance, to within 1.5cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("in) of either end. With right sides facing, pin the gussets to the bag front. Machine stitch the gussets in place, to within 1.5cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("in) of the bottom of the bag.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/13-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("6")]), _vm._v(" Pin the ends of the gussets to the sides of the bag base. Machine stitch in place to within 1.5cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("in) of the end of the far side.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("7")]), _vm._v(" Machine stitch the ruffled ribbon around the geisha picture.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("8")]), _vm._v(" Pin the bag back to the gussets and base, and machine stitch in place.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("9")]), _vm._v(" Assemble the bag lining in the same way as the main bag.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("10")]), _vm._v(" Clip the corners of the bag and press open the seams. Turn through. Insert the lining, wrong side out, into the bag. Pin and tack (baste) the top edges of the lining and the bag together. Machine stitch. Turn over the top of the bag by 1.5cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("in). Press under the raw edge and slipstitch the turning.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/14-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("11")]), _vm._v(" Press the handles in half, right sides together. Machine stitch along the side and one end, using a 1cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("8")]), _vm._v("in) seam allowance. Clip the corners and trim the seams, then turn through the handles and press. Turn in the raw edges at the end of each handle and slipstitch the opening.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/15-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("12")]), _vm._v(" Pin the handles to the front and back of the bag, 2cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) in from the side seams. To secure the handles, machine stitch a square 1mm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("20")]), _vm._v("in) from the edge and finish with a line of stitching from corner to corner for extra strength.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/15-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("13")]), _vm._v(" Sew a button centrally at the base of each handle for decoration.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42756142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c01.vue
// module id = 69
// module chunks = 0